module.exports = __webpack_public_path__ + "img/verify4.22e9f5aa.png";